var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',[_c('img',{attrs:{"src":"https://test-file.haoxinqing.cn/data/man/online/content/20210330/20210330153629.png  ","alt":""}})])])
}]

export { render, staticRenderFns }